<template>
    <div>
        <p class="text-xl mb-4" v-if="step === 0">Select an English {{ model }} to translate</p>
        <model-list
            v-if="step === 0"
            :listRoute="listRoute"
            :label="label"
            :multiple="multiple"
            :selected="selected"
            @created="created"
            @deselect-all="$emit('deselect-all')"
            @select-all="(selectAllObjects) => $emit('select-all', selectAllObjects)"
        />
        <p class="text-xl mb-4" v-if="step === 1">Create {{ language.name }} {{ baseDocument.name }}</p>
        <component
            :follow-redirects="false"
            v-if="step === 1"
            :language-data="language"
            :is="formName"
            :label="label"
            :base-document="baseDocument"
            :formName="formName"
            :model="model"
            :data="object"
            :selected="selected"
            :multiple="multiple"
            @created="created"
            :submit-via-ajax="true"
            :formRoute="formRoute"
            :listRoute="listRoute"
        ></component>
        </div>
</template>

<script>
import ModelList from "./ModelList";
export default {
    name: "TwoStepCreate",
    components: {ModelList},
    props:{
        formRoute: {
            type: String,
            required: false,
        },
        formName: {
          type: String,
          required: true
        },
        listRoute: {
            type: String,
            required: false,
        },
        model: {
            type: String,
        },
        multiple: {
            type: Boolean,
        },
        selected: {
            type: Array,
            default: () => [],
        },
        label: String,
        routeKeyName: String,
        object: Object,
        language: Object
    },
    data(){
        return {
            baseDocument: null,
            step: 0
        };
    },
    methods:{
        created(value){
            if(this.step === 0) {
                this.baseDocument = value
                this.step++;
                return;
            }
            this.$emit('created', value);
        }
    }
}
</script>
